import store from '@/state/store'

export default [
  {
    path: '/',
    name: 'default',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/default'),
  },
  {
    path: '/403',
    name: 'Forbidden access',
    meta: {
      authRequired: false,
    },
    component: () => import('./views/403.vue'),
  },
  {
    path: '/password-reset',
    name: 'Reset password',
    meta: {
      authRequired: false,
    },
    component: () => import('./views/account/password-reset'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/account/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('./views/account/register'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/forgot-password',
    name: 'Forgot password',
    component: () => import('./views/account/forgot-password'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          store.dispatch('auth/logOut')
        } else {
          store.dispatch('authfack/logout')
        }
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.push('/login')
        )
        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: 'default' } : { ...routeFrom })
      },
    },
  },
  {
    path: '/users',
    name: 'users',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/users/default'),
  },
  {
    path: '/pages/:displayedMode?/:album?/:volume?',
    name: 'pages-list',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/pages/list'),
  },
  {
    path: '/inventories/list',
    name: 'inventories-list',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/inventories/list'),
  },
  {
    path: '/drawings/list',
    name: 'drawings-list',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/drawings/list'),
  },
  {
    path: '/albums/list',
    name: 'albums-list',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/albums/list'),
  },
  {
    path: '/persons/list',
    name: 'persons-list',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/persons/list'),
  },
  {
    path: '/locations/list',
    name: 'locations-list',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/locations/list'),
  },
  {
    path: '/correspondences/list',
    name: 'correspondences-list',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/correspondences/list'),
  },
  {
    path: '/newspapers/grid',
    name: 'newspapers-grid',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/newspapers/grid'),
  },
  {
    path: '/notebooks/grid',
    name: 'notebooks-grid',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/notebooks/grid'),
  },
]
